<script lang="ts">
	import { ButtonComponent } from "ui";
	import { postWithJwt, serverlessRoutes } from "lib";
	import { showAlert } from "stores";
	
	async function handleGenerateWorkout() {
		try {
			// Extract clientId from URL
			const urlParts = window.location.hash.split('/');
			const profileIndex = urlParts.indexOf('profile');
			const clientId = profileIndex !== -1 ? urlParts[profileIndex + 1] : null;
			
			if (!clientId) {
				throw new Error("Client ID not found in URL");
			}
			
			const response = await postWithJwt(`${serverlessRoutes.WORKOUT}/generate-ai`, {
				clientId: parseInt(clientId)
			});
			
			// Handle response data
			console.log("Generated workout:", response);
		} catch (error) {
			$showAlert.message = error.message || "Failed to generate workout";
		}
	}
	
	function handleSaveWorkout() {
		// Placeholder for save functionality
		console.log("Save workout clicked");
	}
</script>

<div class="flex gap-4 p-4">
	<ButtonComponent on:click={handleGenerateWorkout}>
		GENERATE_WORKOUT
	</ButtonComponent>
	
	<ButtonComponent on:click={handleSaveWorkout}>
		SAVE_WORKOUT
	</ButtonComponent>
</div>
